import {Injectable} from '@angular/core';
import {AbstractService} from '../common/abstract-service';
import {Search} from '../common/search';
import {SERVIZI_API_PATH, TELE_BORSA_API} from '../constants/constants';
import {Servizio} from '../model/servizio';
import {HttpClient} from '@angular/common/http';
import {Quotazione} from '../model/quotazione.model';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Borsa} from '../model/borsa.model';

@Injectable({
    providedIn: 'root'
})
export class QuotazioneService {

    constructor(protected http: HttpClient) {
    }


    public latest(): Observable<Borsa> {
        return this.http.get<Borsa>(TELE_BORSA_API);
    }

}
